import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { ProductCategoryKey } from '@app/types/catalog';
import { Common, EmptyKey } from '@app/types/common';
import { OrderStatus, OrderStatusKey, OrderTypeKey } from '@app/types/order';

/**
 * Order search form
 */
export interface OrderSearchFormData {
  dateFrom: string;
  dateTo: string;
  month: string;
  sort: string;
  status: OrderStatusKey | EmptyKey;
}
export const OrderSearchFormDefaultValues: OrderSearchFormData = {
  dateFrom: '',
  dateTo: '',
  month: '',
  sort: 'createdAt desc',
  status: Common.EMPTY,
};
export const OrderSearchForm = {
  defaultValues: OrderSearchFormDefaultValues,
  mode: 'all',
  resolver: zodResolver(
    z.object({
      dateFrom: z.string(),
      dateTo: z.string(),
      month: z.string(),
      sort: z.string(),
      status: z.string(),
    })
  ),
} as const;

/**
 * Order CSV download form
 */
export interface OrderCsvDownloadFormKey {
  dateFrom: string;
  dateTo: string;
  organizationId: string;
  productCategory: ProductCategoryKey | EmptyKey;
  status: OrderStatusKey;
}
export interface OrderCsvUploadFormKey {
  childOrganizationId: string;
  orderType: OrderTypeKey | '';
  parentOrganizationId: string;
}
export const OrderCsvDownloadFormDefaultValues: OrderCsvDownloadFormKey = {
  dateFrom: '',
  dateTo: '',
  organizationId: '',
  productCategory: Common.EMPTY,
  status: OrderStatus.PENDING,
};
export const OrderCsvUploadFormDefaultValues: OrderCsvUploadFormKey = {
  childOrganizationId: '',
  orderType: '',
  parentOrganizationId: '',
};
export const OrderCsvDownloadForm = {
  defaultValues: OrderCsvDownloadFormDefaultValues,
  mode: 'all',
  resolver: zodResolver(
    z.object({
      dateFrom: z.string().min(1),
      dateTo: z.string().min(1),
      organizationId: z.string().min(1),
      productCategory: z.string(),
      status: z.string(),
    })
  ),
} as const;

export const OrderCsvUploadForm = {
  defaultValues: OrderCsvUploadFormDefaultValues,
  mode: 'all',
  resolver: zodResolver(
    z.object({
      childOrganizationId: z
        .string()
        .min(1, { message: '所属企業を選択してください.' }),
      orderType: z.string(),
      parentOrganizationId: z
        .string()
        .min(1, { message: '窓口を選択してください' }),
    })
  ),
} as const;
